import { toInteger } from 'lodash';
import { createCanvas } from '@/utils/file-kit';
import { ILayerProps, ISize } from '@/version-types';
import { renderLayerContentToCanvas } from './render-to-canvas';

/**
 * 导出用于绘制到舞台的图层结果
 *
 * - 为了方便，目前每个图层实际都是按舞台尺寸进行绘制
 * - 后续如果要优化性能，可以考虑实际图层渲染大小进行绘制
 *
 * @param layer - 图层属性
 * @param stageSize - 舞台尺寸
 */
export const renderLayerToStage = async (
    identity: string,
    layer: ILayerProps,
    stageSize: ISize,
): Promise<HTMLCanvasElement | undefined> => {
    const layerImage = await renderLayerContentToCanvas(identity, layer, false);

    if (!layerImage) return;

    // TODO: 以下逻辑理论上是所有图层都是一样的处理方式，是否应该剥离到框架核心中
    // console.time('===========生成时间');
    const { width, height, left, top, opacity, rotate } = layer;
    const { width: stageWidth, height: stageHeight } = stageSize;
    const resultWidth = toInteger(width);
    const resultHeight = toInteger(height);
    const centerPoint = {
        x: resultWidth / 2 + left,
        y: resultHeight / 2 + top,
    };
    const drawOffsetPoint = {
        x: -resultWidth / 2,
        y: -resultHeight / 2,
    };

    const { canvas: stageCanvas, ctx: stageCtx } = createCanvas(stageWidth, stageHeight);

    stageCtx.translate(centerPoint.x, centerPoint.y);
    stageCtx.rotate((Math.PI / 180) * rotate);
    // WHY: 为什么透明度不直接在 renderLayerContentToCanvas 里面处理
    stageCtx.globalAlpha = opacity;
    stageCtx.drawImage(
        layerImage,
        0,
        0,
        resultWidth,
        resultHeight,
        drawOffsetPoint.x,
        drawOffsetPoint.y,
        resultWidth,
        resultHeight,
    );
    // console.timeEnd('===========生成时间');
    return stageCanvas;
};
